import { render, staticRenderFns } from "./BenefiaryHeader.vue?vue&type=template&id=48029042"
import script from "./BenefiaryHeader.vue?vue&type=script&lang=js"
export * from "./BenefiaryHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports